import LoginButtonTemplate from "./LoginButtonTemplate";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import useKakaoLogin from "../../hooks/useKakaoLogin";

export default function KakaoLoginButton({
  render,
  onNotCoach,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
  onNotCoach?: () => void;
}) {
  const handleLogin = useKakaoLogin();
  const user = useRecoilValue(userAtom);

  return (
    <LoginButtonTemplate
      loginType="kakao"
      action={() => {
        handleLogin();
      }}
      isLoggedIn={!!user?.accessToken}
      widthPx={320}
      heightPx={54}
    />
  );
}
